import { Outlet } from 'react-router-dom';

import { SidebarProvider } from '@/contexts/sidebar-context';

import { SettingsLayoutWrapper } from './settings-layout-wrapper';

export function SettingsLayout() {
  return (
    <SidebarProvider initialCollapsed={false}>
      <SettingsLayoutWrapper>
        <Outlet />
      </SettingsLayoutWrapper>
    </SidebarProvider>
  );
}
